export default __webpack_public_path__ + "src/images/packages/unembeza-boutique-lodge/d1ff3a3b81f7b7d3378e6343db8b451e-5.png";